import moment from "moment";

export const DateCell = ({ value }) => {
  if (!value) return null;
  return moment(value).format("DD/MM/YYYY");
};
